export default {
      id: "ic_close_circle_black-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_close_circle_black-usage",
      toString: function () {
        return this.url;
      }
    }